<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="1200" scrollable persistent>
      <v-card class="rounded-lg">
        <v-card-title>
          {{ _detail.PolicyHeader }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <div v-html="_detail.PolicyDetail"></div>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="close()">
            {{ $t("consentform.off") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "_header", "_detail"],
  data: function () {
    return {};
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogDelete");
        }
      },
    },
  },
  methods: {
    close() {
      this.$emit("closeDialogDelete");
    },
  },
};
</script>
